<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('label.numberOfSlaughter')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['outBuildingQty', validatorRules.outBuildingQty]" :placeholder="$t('label.pleaseEnterTheNumberOfSlaughters')"
                              :disabled="true"
                              style="width: 84%"/>
{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.numberOfContracts')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['conQty', validatorRules.conQty]" :placeholder="$t('label.pleaseEnterTheNumberOfContracts')"
                              :disabled="true"
                              style="width: 84%"/>
{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.catchWeight')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['outBuildingWeight', validatorRules.outBuildingWeight]"
                              :disabled="true"
                              :placeholder="$t('label.catchWeight')" style="width: 84%"/>
              kg
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.deductedWeight')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['reduceWeight', validatorRules.reduceWeight]" :placeholder="$t('label.pleaseEnterTheDeductionWeight')"
                              @change="subsidyChanged($event,'1')"
                              style="width: 84%"/>
              kg
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item :label="$t('label.deductionAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['deductionAmount', validatorRules.deductionAmount]" :placeholder="$t('label.pleaseEnterTheAmountToBeDeducted')"
                              @change="subsidyChanged($event,'2')"
                              style="width: 84%"/>
              {{ $t('label.yuanKg') }}
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item :label="$t('label.increaseInWeight')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['addWeight', validatorRules.addWeight]":placeholder="$t('label.pleaseEnterTheIncreaseWeight')"
                              @change="subsidyChanged($event,'3')"
                              style="width: 84%"/>
              kg
            </a-form-item>
          </a-col>


          <a-col :span="8">
            <a-form-item :label="$t('label.increaseAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['increaseAmount', validatorRules.increaseAmount]" :placeholder="$t('label.pleaseEnterTheIncreaseAmount')"
                              @change="subsidyChanged($event,'4')"
                              style="width: 84%"/>
              {{ $t('label.yuanKg') }}
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item :label="$t('label.averageUnitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['unitPrice', validatorRules.unitPrice]" :placeholder="$t('label.pleaseEnterTheAverageUnitPrice')"
                              :disabled="true"
                              style="width: 84%"/>
              {{ $t('label.yuanKg') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.amount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['totalPrice', validatorRules.totalPrice]" :placeholder="$t('label.amount')"
                              :disabled="true"
                              style="width: 84%"/>
              {{ $t('label.yuanKg') }}
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.columnSummary')" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="efsStBreedSettleOutListTable.loading"
          :columns="efsStBreedSettleOutListTable.columns"
          :dataSource="efsStBreedSettleOutListTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"
          @valueChange="handleValueChange"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>
<script>
    import pick from 'lodash.pick'
    import { getAction } from '@/api/manage'
    import { validateDuplicateValue } from '@/utils/util'
    import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
    import JFormContainer from '@/components/jeecg/JFormContainer'
    import JDate from '@/components/jeecg/JDate'
    import JDictSelectTag from '@/components/dict/JDictSelectTag'
    import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'

    export default {
        name: 'SettleOutListForm',
        mixins: [JEditableTableMixin],
        components: {
            JFormContainer,
            JDate,
            JDictSelectTag,
        },
        props: {
            //流程表单data
            formData: {
                type: Object,
                default: () => {
                },
                required: false
            },
            //表单模式：false流程表单 true普通表单
            formBpm: {
                type: Boolean,
                default: false,
                required: false
            },
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data() {
            return {
                model: {},
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
                labelCol2: {
                    xs: { span: 24 },
                    sm: { span: 3 },
                },
                wrapperCol2: {
                    xs: { span: 24 },
                    sm: { span: 20 },
                },
                validatorRules: {
                    outBuildingQty: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheNumberOfSlaughters') },
                            { pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/, message: this.$t('label.theNumberOfSlaughterMustBeGreaterThan0')},
                        ]
                    },
                    conQty: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheContractQuantity') },
                            { pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/, message: this.$t('label.contractQuantityMustBeGreaterThan0')},
                        ]
                    },
                    outBuildingWeight: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheSlaughterWeight') },
                            { pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/, message: this.$t('label.slaughterWeightMustBeGreaterThan0')},
                        ]
                    },
                    reduceWeight: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheDeductionWeight') },
                            { pattern: /^\d+(.\d+)?$/, message: this.$t('label.deductedWeightMustBeGreaterThanOrEqualTo0')},
                        ]
                    },
                    addWeight: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheIncreaseWeight') },
                            { pattern: /^\d+(.\d+)?$/, message: this.$t('label.increaseWeightMustBeGreaterThanOrEqualTo0')},
                        ]
                    },
                    unitPrice: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheUnitPrice') },
                            { pattern: /^\d+(.\d+)?$/, message: this.$t('label.unitPriceMustBeGreaterThanOrEqualTo0')},
                        ]
                    },
                    totalPrice: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheAmount') },
                            { pattern: /^\d+(.\d+)?$/, message: this.$t('label.amountMustBeGreaterThanOrEqualTo0')},
                        ]
                    },
                    deductionAmount: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheAmountToBeDeducted') },
                            { pattern: /^\d+(.\d+)?$/, message: this.$t('label.deductionAmountMustBeGreaterThanOrEqualTo0')},
                        ]
                    },
                    increaseAmount: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheIncreaseAmount') },
                            { pattern: /^\d+(.\d+)?$/, message: this.$t('label.pleaseEnterTheIncreaseAmount')},
                        ]
                    },
                },
                refKeys: ['efsStBreedSettleOutList',],
                tableKeys: ['efsStBreedSettleOutList',],
                activeKey: 'efsStBreedSettleOutList',
                // 合同价格清单详情
                efsStBreedSettleOutListTable: {
                    loading: false,
                    dataSource: [],
                    columns: [
                        {
                            title: this.$t('tableHeader.materialCode'),
                            key: 'mmCode',
                            type: FormTypes.normal,
                            width: '200px',
                        },
                        {
                            title: this.$t('tableHeader.materialName'),
                            key: 'mmName',
                            type: FormTypes.normal,
                            width: '150px',
                        },
                        {
                            //title: '出栏羽数',
                            title: "日期",
                            key: 'postDate',
                            type: FormTypes.normal,
                            width: '150px',
                        },
                        {
                            //title: '出栏羽数',
                            title: "日龄",
                            key: 'days',
                            type: FormTypes.normal,
                            width: '100px',
                        },
                        {
                            //title: '出栏羽数',
                            title: this.$t('tableHeader.numberOfSlaughtered'),
                            key: 'qty',
                            type: FormTypes.normal,
                            width: '100px',
                        },
                        {
                            //title: '出栏羽数',
                            title: "回收单价",
                            key: 'recoveryPrice',
                            type: FormTypes.inputNumber,
                            width: '100px',
                        },
                        {
                            //title: '出栏重量(kg)',
                            title: this.$t('tableHeader.weightOfSlaughter'),
                            key: 'actualAmount',
                            type: FormTypes.normal,
                            width: '150px',
                        },
                        {
                            //title: '平均羽重(kg/羽)',
                            title: this.$t('tableHeader.averagePigeonWeight'),
                            key: 'avgWeight',
                            type: FormTypes.normal,
                            width: '150px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                            defaultValue: '',
                        },
                        {
                            //title: '回收金额',
                            title: this.$t('tableHeader.amountOfRecovery'),
                            key: 'recoveryAmount',
                            type: FormTypes.normal,
                            width: '150px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                    ]
                },
                url: {
                    efsMdContractPriceListDetail: {
                        list: '/newContractManage/efsMdContract/queryEfsMdContractPriceListDetailByChangeMainId'
                    },
                },
                outBuildWeightTmp: 0,
                addWeightTmp: 0,
                reduceWeightTmp: 0,
                unitPriceTmp: 0,
                totalRecoveryAmount: 0,
            }
        },
        computed: {
            formDisabled() {
                if (this.formBpm === true) {
                    if (this.formData.disabled === false) {
                        return false
                    }
                    return true
                }
                return this.disabled
            },
            showFlowSubmitButton() {
                if (this.formBpm === true) {
                    if (this.formData.disabled === false) {
                        return true
                    }
                }
                return false
            }
        },
        methods: {
            initFormData(url, id) {
                this.clearFormData()
                if (!id) {
                    this.edit({})
                } else {
                    getAction(url, { id: id }).then(res => {
                        if (res.success) {
                            let records = res.result
                            this.efsStBreedSettleOutListTable.dataSource = res.result.efsBreedOutVoList
                            this.edit(records)
                        }
                    })
                }
            },
            formDataByBreedCode(url, code) {
                getAction(url, { breedCode: code }).then(res => {
                    if (res.success) {
                        this.form.setFieldsValue({
                            outBuildingQty: res.result.outBuildingQty,
                            conQty: res.result.conQty,
                            outBuildingWeight: res.result.outBuildingWeight,
                            totalPrice: res.result.totalPrice,
                        })
                        this.efsStBreedSettleOutListTable.dataSource = res.result.efsBreedOutVoList
                        // 棚前重量(乘单价算总价用)
                        this.outBuildWeightTmp = res.result.weight;
                        this.totalRecoveryAmount= res.result.totalPrice;
                        this.$bus.$emit("totalRecoveryAmount", res.result.totalPrice);
                    }
                })
            },
            getAllTable() {
                let values = this.tableKeys.map(key => getRefPromise(this, key))
                return Promise.all(values)
            },
            edit(record) {
                this.model = Object.assign({}, record)
                let fieldval = pick(this.model, 'outBuildingQty', 'conQty', 'outBuildingWeight', 'reduceWeight', 'addWeight', 'unitPrice', 'totalPrice','deductionAmount','increaseAmount')
                if (this.model.id) {
                    let params = { conCode: this.model.conCode }
                    this.requestSubTableData(this.url.efsMdContractPriceListDetail.list, params, this.efsStBreedSettleOutListTable)
                }
                this.$nextTick(() => {
                    this.form.setFieldsValue(fieldval)
                })
            },
            getFormData() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        if (!this.efsStBreedSettleOutListTable.dataSource) {
                            this.$emit('validateError', '出栏明细不能为空！')
                        }
                        let formdata = Object.assign(this.model, values)
                        console.log(this.efsStBreedSettleOutListTable.dataSource)
                        this.efsStBreedSettleOutListTable.dataSource.map((item, index) => {
                            item.outBuildingQty = formdata.outBuildingQty
                            item.conQty = formdata.conQty
                            item.outBuildingWeight = formdata.outBuildingWeight
                            item.reduceWeight = formdata.reduceWeight
                            item.addWeight = formdata.addWeight
                            item.unitPrice = formdata.unitPrice
                            item.totalPrice = formdata.totalPrice
                            item.deductionAmount = formdata.deductionAmount
                            item.increaseAmount = formdata.increaseAmount
                        })
                    } else {
                        this.$emit('validateError', '出栏明细校验未通过')
                        return
                    }
                })
                return this.efsStBreedSettleOutListTable.dataSource
            },
            clearFormData() {
                this.form.resetFields()
                this.model = {}
                this.efsStBreedSettleOutListTable.dataSource = []
            },

            subsidyChanged(event,type){
                let outBuildingWeight= this.form.getFieldValue('outBuildingWeight');//出栏重量
                let totalPrice=this.totalRecoveryAmount;//出栏汇总金额

                let reduceWeight;
                if(type=="1"){//扣减重量
                    reduceWeight=event;
                }else{
                    reduceWeight= this.form.getFieldValue('reduceWeight');
                }

                let deductionAmount;
                if(type=="2"){//扣减金额
                    deductionAmount=event;
                }else{
                    deductionAmount= this.form.getFieldValue('deductionAmount');
                }

                let addWeight;
                if(type=="3"){//增加重量
                    addWeight=event;
                }else{
                    addWeight= this.form.getFieldValue('addWeight');
                }

                let increaseAmount;
                if(type=="4"){//增加金额
                    increaseAmount=event;
                }else{
                    increaseAmount= this.form.getFieldValue('increaseAmount');
                }
                //平均单价
                if(outBuildingWeight!=null&&reduceWeight!=null&&addWeight!=null&&totalPrice!=null&&deductionAmount!=null&&increaseAmount!=null){
                    let total=Number(((totalPrice-deductionAmount+increaseAmount)/(outBuildingWeight-reduceWeight+addWeight))).toFixed(2);
                    this.form.setFieldsValue({unitPrice:total});
                }else{
                    this.form.setFieldsValue({unitPrice:0});
                }
                //金额
                if(totalPrice!=null&&deductionAmount!=null&&increaseAmount!=null){
                    let total=Number((totalPrice-deductionAmount+increaseAmount)).toFixed(2);
                    this.form.setFieldsValue({totalPrice:total});
                }else{
                    this.form.setFieldsValue({totalPrice:0});
                }
            },
            handleValueChange(event) {
                console.log(event)
                if(event.column.key === 'recoveryPrice'){
                    let qty=event.row.qty;
                    let recoveryPrice=event.row.recoveryPrice;
                    let totalPrice= this.form.getFieldValue('totalPrice')-event.row.recoveryAmount;
                    let recoveryAmount=0;
                    if(qty!=null){
                        recoveryAmount=Number(qty*recoveryPrice).toFixed(2);
                    }
                    this.$refs.efsStBreedSettleOutList.setValues([{
                        rowKey: event.row.id,
                        values: {
                            recoveryAmount: recoveryAmount
                        }
                    }]);
                    this.efsStBreedSettleOutListTable.dataSource[event.index]['recoveryPrice'] = event.value
                    this.efsStBreedSettleOutListTable.dataSource[event.index]['recoveryAmount'] = recoveryAmount
                    this.form.setFieldsValue({totalPrice:(Number(totalPrice)+Number(recoveryAmount)).toFixed(2)});
                }
                this.$forceUpdate()
            },
        }
    }
</script>
